import { Nav } from "reactstrap";
import Layout from "../../../components/custom/Layout";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { useEffect, useRef, useState } from "react";
import FileBase64 from 'react-file-base64';
import * as yup from 'yup';
import SunEditor, { buttonList } from 'suneditor-react';

import { TabContent } from "reactstrap";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import useTypedForm from "../../../components/custom/hookForm/useTypedForm";
import { CorporateEmail, IFile } from "../../../globals/interfaces";
import { FormGroup } from "reactstrap";
import { Label } from "reactstrap";
import styled from "styled-components";
import { Button } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import apiClient from "../../../apiClient";
import { getTsDate, notify } from "../../../utils";
import useLoading from "../../../customHooks/useLoading";
import Logs from "./Logs";
import _ from "lodash";

export type Tab = 'SEND_EMAIL' | 'LOGS';

const yupSchema = yup.object({
    subject: yup.string().required(),
    body: yup.string().required(),
    created: yup.date().required()
});

export default function CorpEmployeeCommunication() {

    const { setLoading } = useLoading();
    const [attachmentsKey, setAttachmentsKey] = useState(0);
    const [activeTab, setActiveTab] = useState<Tab>('SEND_EMAIL');
    const editorRef = useRef();
    const defaultData = {
        created: getTsDate()
    }

    const toggleTab = (tab: Tab) => setActiveTab(tab);

    const {
        formState: {
            isValid,
            errors
        },
        setValue,
        watch,
        FormInput,
        handleSubmit,
        trigger,
        reset
    } = useTypedForm<CorporateEmail>({
        mode: 'all',
        resolver: yupResolver(yupSchema)
    });

    const body = watch('body');

    useEffect(() => {
        reset(defaultData);
        trigger();
    }, []);

    const handleEditorChange = (content: string) => {
        setValue('body', content, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
        });
    };

    const setFile = (files: Array<IFile>) => {
        setValue('attachments', files);
    }

    const sendEmail = async (data: CorporateEmail) => {
        try {
            setLoading(true);
            const res = await apiClient.post(`/corporate-email`, data);
            reset(defaultData);
            setAttachmentsKey(prev => prev + 1);
            // Clear SunEditor content
            if (editorRef.current) {
                // @ts-ignore
                editorRef.current.editor.setContents(''); // Clear the editor content
            }
            notify('Email sent');
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    return (
        <Layout>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Send Email"
                    tabId="SEND_EMAIL"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Logs"
                    tabId="LOGS"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'SEND_EMAIL'}>
                    <div>
                        <FormInput
                            label={'Subject'}
                            name={'subject'}
                        />
                        <EditorWrapper>
                            <SunEditor
                                enable={true}
                                ref={editorRef}
                                defaultValue=""
                                setOptions={{
                                    buttonList: buttonList.complex,
                                }}
                                height={300}
                                onChange={handleEditorChange}
                            />
                        </EditorWrapper>
                        <FormGroup>
                            <Label className={'mr-2'}>Attachments</Label>
                            <FileBase64
                                onDone={setFile}
                                multiple
                                key={attachmentsKey}
                            />
                        </FormGroup>
                        <FlexEndDiv>
                            <Button 
                                disabled={!isValid}
                                onClick={handleSubmit(sendEmail)}
                            >
                                Email all Employees
                        </Button>
                        </FlexEndDiv>
                    </div>
                </CustomTabPane>
                <CustomTabPane<Tab> tabId={'LOGS'}>
                    <Logs activeTab={activeTab} />
                </CustomTabPane>
            </TabContent>       
        </Layout>
    );
}

const FlexEndDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const EditorWrapper = styled.div`
    position: relative;
    z-index: 1; /* Adjust to keep it under your nav */
`;